export const NAV_LINKS = [
  { label: 'Gallery', href: '#gallery' },
  { label: 'Pricing', href: '#pricing' },
  { label: 'FAQ', href: '#faq' },
];

export const HOW_IT_STAYS_GOOD = [
  {
    icon: 'ri-play-circle-line',
    title: 'Run it on your data',
    body: 'Fork the artifact into your business. The first honest run is on your slots, your customers, your files.',
  },
  {
    icon: 'ri-medal-line',
    title: 'Score the contract',
    body: 'A published 0-12 score says whether it still does the job. If it drops, you see it. A chat window cannot keep that promise.',
  },
  {
    icon: 'ri-refresh-line',
    title: 'Train until it holds',
    body: 'Buy runs to train it back. Next month, when the model moves, you re-run the same contract instead of generating a new disposable app.',
  },
];

export const DESKTOP_FEATURES = [
  { icon: 'ri-macbook-line', title: 'Always there', body: 'Studio in a window, not a tab that dies when you close Chrome.' },
  { icon: 'ri-notification-3-line', title: 'Local first', body: 'LM Studio and your own keys stay on the machine. Cloud loops are optional.' },
  { icon: 'ri-key-2-line', title: 'BYOK locally', body: 'Run with your own keys, or LM Studio on localhost. Cloud loops still meter credits until you start hosting.' },
];

export const FAQS = [
  {
    q: 'What is Sourcetape?',
    a: 'A launchpad for founders. Describe the app you want, get a working artifact, and keep training it so it stays good when models update.',
  },
  {
    q: 'How is this not Lovable?',
    a: 'Those tools sell a one-shot generate. Sourcetape sells repeatability: a score against a known outcome, and training until that score holds. We are not an app builder that also trains.',
  },
  {
    q: 'What is the score?',
    a: 'A live run is scored 0-12 against the outcome you named. Hosted runs spend credits until you subscribe. Local models via LM Studio do not.',
  },
  {
    q: 'What do credits buy?',
    a: 'Credits meter hosted model work while you compose the site. New accounts get 20 free credits. Going live is a hosting subscription with a card, not a token pack.',
  },
  {
    q: 'Do I need an account to try?',
    a: 'Describe the app on the homepage, then create an account so Composer can keep that chat. New accounts get 20 free hosted credits. Local models via LM Studio work on this machine.',
  },
  {
    q: 'How do I publish the site?',
    a: 'When the frontend looks right, start hosting with a card. After payment we apply isolated Terraform that only adds your slug.sourcetape.io record. A custom domain later gets its own hosted zone.',
  },
  {
    q: 'Can I sign in with Google?',
    a: 'Yes. Google SSO creates an account from your verified email, or signs you into the existing one. Email and password still work.',
  },
  {
    q: 'Is there a desktop app?',
    a: 'A Mac and Windows desktop app is in progress. Downloads are coming soon. Until then, the builder runs in the browser. Local models via LM Studio work on localhost.',
  },
  {
    q: 'What is Studio?',
    a: 'Studio is the graph for teams who want to see the steps. Most founders never open it. The graph stays available from the dashboard after you start a build.',
  },
];
